module.exports = __webpack_public_path__ + "static/img/Swipel Clamp (Hidup).51eb19b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/Swipel Clamp (Hidup).jpg
// module id = 106
// module chunks = 1